export default function PHP_strpos() {
  return (
    <div>
      <h1>PHP_strpos</h1>
    </div>
  );
}
